import { render } from "./LevelUpBanner.vue?vue&type=template&id=5066f458&scoped=true"
import script from "./LevelUpBanner.vue?vue&type=script&lang=js"
export * from "./LevelUpBanner.vue?vue&type=script&lang=js"

import "./LevelUpBanner.vue?vue&type=style&index=0&id=5066f458&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5066f458"]])

export default __exports__